import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ModalModule, BsModalService } from 'ngx-bootstrap/modal';

import { DataLoaderModule } from '@shared/data-loader/data-loader.module';
import { FooterModule } from '@shared/footer/footer.module';
import { HeaderModule } from '@shared/header/header.module';

import { FullPageLoaderComponent } from './full-page-loader/full-page-loader.component';

@NgModule({
	declarations: [FullPageLoaderComponent],
	imports: [
		CommonModule,
		NgbModule,
		ModalModule.forRoot(),
		HeaderModule,
		FooterModule,
		DataLoaderModule,
		TranslateModule

	],
	exports: [FullPageLoaderComponent]
})
export class FullPageLoaderModule {
	static forRoot(): ModuleWithProviders<FullPageLoaderModule> {
		return {
			ngModule: FullPageLoaderModule,
			providers: [BsModalService]
		};
	}
}
